module.exports = __webpack_public_path__ + "static/media/operations_dashboard.f3a22896.svg";